/**
 * Maps backend (Slovak) auth error messages to English for display in login/register forms.
 */
const AUTH_ERROR_EN = {
  // Login
  'Email je povinný': 'Email is required',
  'Neplatné prihlasovacie údaje': 'Invalid email or password',
  'Tento účet používa prihlásenie cez Google. Použite tlačidlo Prihlásiť sa cez Google.': 'This account uses Google sign-in. Please use the Sign in with Google button.',
  // Register
  'Email a heslo sú povinné': 'Email and password are required',
  'Zadajte platnú e-mailovú adresu': 'Please enter a valid email address',
  'Heslo musí mať aspoň 6 znakov': 'Password must be at least 6 characters',
  'Účet s týmto e-mailom už existuje': 'An account with this email already exists',
  'Registrácia zlyhala': 'Registration failed',
  // Google
  'Chýba Google token (credential)': 'Google sign-in token is missing',
  'Prihlásenie cez Google nie je nakonfigurované (GOOGLE_CLIENT_ID)': 'Google sign-in is not configured',
  'Účet s touto e-mailovou adresou už existuje. Prihláste sa heslom alebo obnovte heslo.': 'An account with this email already exists. Sign in with password or reset password.',
};

export function authErrorToEnglish(backendMessage) {
  if (!backendMessage || typeof backendMessage !== 'string') return backendMessage;
  return AUTH_ERROR_EN[backendMessage.trim()] || backendMessage;
}
